import React from 'react'

const Claimed = () => {
    return (
        <>
            <section className="community-section claimed-rain">
                <div className="custom-container">
                    <div className="parent">
                        <video
                            className="main-community-video"
                            muted="muted"
                            playsinline="playsinline"
                            autoPlay
                            loop
                            width="100%"
                            id="myVideo"
                        >
                            <source src="https://res.cloudinary.com/drt6vurtt/video/upload/v1736357338/rain-prediction/joinvideo_o0v9oi.mov" type="video/mp4" />
                        </video>
                        <div className="left-side">
                            <h4>Havent claimed your $RAIN?</h4>
                            <p>Head over to Gems launchpad and claim your rain today!</p>
                            <a href="https://gems.vip" target='_blank' className='btn-claim'>Claim $RAIN</a>
                        </div>
                        <div className="right-side">
                            <img src="\assets\getrain\rainimg.png" alt="img" className='img-fluid' />

                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Claimed
